import React, { useState, useEffect } from "react";
import { Grid, Box, Typography } from "@mui/material";
import SideBar from "../../components/Sidebar/index";
import { Card, Breadcrumb, Form, Input, Select, Button } from "antd";
import { queenApiCalling } from "../../constant/API";
import { HomeOutlined, UserOutlined } from "@ant-design/icons";
import { ToastContainer, toast } from "react-toastify";
import { SyncLoader } from "react-spinners";
import "../../css/main.css";

export default function ServiceCharge() {
  const formRef = React.useRef(null);
  const [isLoading, setIsLoading] = useState(false);
  const [form] = Form.useForm();

  const onFinish = (v) => {
    setIsLoading(true);
    const params = {
      service_fee: v.service_fee,
      service_fee_fixed: v.service_fee_fixed,
      payment_processing_fee: v.payment_processing_fee,
      ticket_resale_fee: "0",
      action: "UPDATE_SERVICE_CHARGE",
    };
    queenApiCalling(params).then((res) => {
      setIsLoading(false);
      if (res.status === "success") {
        toast.success(res.message);
      } else {
        toast.error(res.message);
      }
    });
  };

  const getServiceCharge = () => {
    let params = { action: "SERVICE_CHARGES" };
    queenApiCalling(params).then((res) => {
      if (res.status === "success") {
        form.setFieldsValue({
          service_fee: res.service_fee,
          service_fee_fixed: res.service_fee_fixed,
          payment_processing_fee: res.processing_fee,
        });
      }
    });
  };

  useEffect(() => {
    getServiceCharge();
  }, []);

  return (
    <Box>
      <Grid>
        <></>
      </Grid>
      <Box md={{ width: "100%" }} style={{ marginTop: "0px" }}>
        <Grid
          container
          rowSpacing={1}
          columnSpacing={{ xs: 1, sm: 1, md: 1 }}
          sx={{ flexDirection: { xs: "column", md: "row" } }}
        >
          <Grid item md={2}>
            <SideBar type={localStorage.getItem("adminSession").role} />
          </Grid>
          <Grid
            md={10}
            container
            rowSpacing={1}
            columnSpacing={{ xs: 1, sm: 1, md: 1 }}
            sx={{ flexDirection: { xs: "column", md: "row" } }}
            style={{ marginTop: "0px" }}
          >
            <Card
              title="Update Service Charge"
              style={{
                width: "98%",
                marginLeft: "1%",
                marginTop: "30px",
              }}
              extra={
                <Breadcrumb
                  items={[
                    {
                      href: "/dashboard",
                      title: <HomeOutlined />,
                    },

                    {
                      title: "Service Charge",
                    },
                  ]}
                />
              }
            >
              <Card style={{ width: "50%" }}>
                <Form
                  ref={formRef}
                  form={form}
                  layout="vertical"
                  name={"complex-form"}
                  labelCol={{
                    span: 8,
                  }}
                  wrapperCol={{
                    span: 24,
                  }}
                  style={{ width: "100%" }}
                  onFinish={onFinish}
                  autoComplete="off"
                  initialValues={{
                    remember: true,
                  }}
                >
                  <Form.Item
                    name="service_fee"
                    label="Service Fee (%)"
                    rules={[
                      {
                        required: true,
                        message: "Please enter service fee",
                      },
                    ]}
                  >
                    <Input placeholder={"Service Fee"} type={"number"} />
                  </Form.Item>
                  <Form.Item
                    name="service_fee_fixed"
                    label="Service Fee($) Fixed"
                    rules={[
                      {
                        required: true,
                        message: "Please enter service fee fixed",
                      },
                    ]}
                  >
                    <Input placeholder={"Service Fee $"} type={"number"} />
                  </Form.Item>
                  <Form.Item
                    name="payment_processing_fee"
                    label="Payment Processing Fee(%)"
                    rules={[
                      {
                        required: true,
                        message: "Please enter payment processing fee",
                      },
                    ]}
                  >
                    <Input
                      placeholder={"Payment Processing Fee $"}
                      type={"number"}
                    />
                  </Form.Item>

                  <Form.Item>
                    {isLoading ? (
                      <SyncLoader
                        color={"008080"}
                        loading={isLoading}
                        size={15}
                        aria-label="Loading Spinner"
                        data-testid="loader"
                      />
                    ) : (
                      <Button
                        type="primary"
                        htmlType="submit"
                        style={{ background: "#fbc531", width: "100%" }}
                      >
                        Update Service Charge
                      </Button>
                    )}
                  </Form.Item>
                </Form>
              </Card>
            </Card>
          </Grid>
        </Grid>
      </Box>
      <ToastContainer />
    </Box>
  );
}
